import ResourceApi from '../ResourceApi';

const ReviewCategoriesResource = {
  index: async (params = {}) => (await ResourceApi.get('/resource/review-categories', params)).data,
};

export default ReviewCategoriesResource;
